import { inject, InjectionToken, NgZone, Provider } from '@angular/core';
import { BroadcastChannelService } from './broadcast-channel.service';
import { BroadcastChannel } from 'broadcast-channel';
export const BROADCAST_CHANNELS = new InjectionToken<Map<string, BroadcastChannel>>('BROADCAST_CHANNEL');
